<template>
  <div>
    <div v-if="!sharedNetworksModal">
      <v-data-table
      :items="virtualProviders"
      :headers="headers"
      min-width="1000px"
      :rows-per-page-items="[25, 50, 100, 250]"
      :key="key"
      item-key="name"
      align-center
      style="cursor: pointer"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <!-- <td class="text-xs-center">
            <v-chip color="light-green" class="white--text" v-if="props.item.isActive" @click="updateStatus(props.item)">Active</v-chip>
            <v-chip color="red" class="white--text" v-else @click="updateStatus(props.item)">Inactive</v-chip>
        </td>-->
        <td
          class="text-xs-center"
          @click="viewSharedNetworksModal(props.item)"
        >{{props.item.virtualProvider.name}}</td>
        <td
          class="text-xs-center"
          @click="viewSharedNetworksModal(props.item)"
        >{{props.item.networkCount}}</td>
      </template>
    </v-data-table>
    </div>
    <div v-if="sharedNetworksModal">
      <v-card>
        <v-toolbar flat color="white">
          <h3
            class="title grey--text"
            v-if="item.virtualProvider"
          >Networks Shared: {{item.virtualProvider.name}}</h3>
          <v-spacer></v-spacer>
          <v-btn round color="primary" class="white--text" @click="saveChanges(item)">Save</v-btn>
          <v-btn flat color="dark-grey"  @click="sharedNetworksModal=false, item={}">Close</v-btn>
        </v-toolbar>
        <v-card-text >
          <v-data-table
            hide-details
            :rows-per-page-items="[250]"
            :items="allNetworks"
            :expand="expand"
            :headers="networkHeaders"
            style="cursor: pointer"
          >
            <template v-slot:items="props">
              <tr @click="props.expanded = !props.expanded">
            <td class="text-xs-left">
              <v-icon v-if="!props.expanded" class="justify-center">chevron_right</v-icon>
              <v-icon v-else>keyboard_arrow_down</v-icon>
              {{props.item.name}}
            </td>
            <td class="text-xs-center" :key="key">
              <v-icon v-if="props.item.sharedPackages.length===item.packages.length" color="light-green">check_circle</v-icon>
              <v-icon v-else-if="props.item.sharedPackages.length>0 && props.item.sharedPackages.length<item.packages.length" color="orange">check_circle</v-icon>
              <v-icon v-else-if="props.item.sharedPackages.length===0" color="red">cancel</v-icon>
            </td>
            <td
          v-if="props.item.networkStatus==='Live'"
          class="text-xs-center"
        >
          <v-chip small :class="`Live white--text caption my-2`">Live</v-chip>
        </td>
        <td
          v-if="props.item.networkStatus==='In Progress'"
          class="text-xs-center"
        >
          <v-chip small :class="`Progress white--text caption my-2`">In Progress</v-chip>
        </td>
        <td
          v-if="props.item.networkStatus==='Planned'"
          class="text-xs-center"
        >
          <v-chip small :class="`planned white--text caption my-2`">Planned</v-chip>
        </td>
         <td class="text-xs-center">
              {{props.item.backhaulType}}
            </td>
            <td class="text-xs-center">
              {{props.item.numberOfUnits}}
            </td>
          </tr>
              <!-- <td>
                <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
              </td>
              <td class="text-xs-center">{{props.item.name}}</td> -->
            </template>
            <template v-slot:expand="props">
          <v-data-table
            :items="item.packages"
            hide-actions
            :headers="networkPackageHeaders"
            v-model="props.item.sharedPackages"
             item-key="id"
          >
            <template v-slot:items="prop">
              <td class="text-xs-center">
        <v-checkbox
        class="text-xs-center"
          v-model="prop.selected"
          primary
          hide-details
         @change="key+=1"
        ></v-checkbox>
      </td>
              <td class="text-xs-center">{{prop.item.packageCode}}</td>
               <td class="text-xs-center">{{prop.item.packagesFnoCat.name}}</td>
              <td class="text-xs-center">{{prop.item.packageBasePrice | currency}}</td>
              <td class="text-xs-center">
                <v-layout justify-center align-center wrap>
                  <v-icon color="light-green">arrow_drop_down</v-icon> {{prop.item.speedProfile.downloadMbps}}
                  <v-icon color="red">arrow_drop_up</v-icon> {{prop.item.speedProfile.uploadMbps}}
                </v-layout>
              </td>
            </template>
          </v-data-table>
        </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
    
    
    <!-- <v-dialog v-model="sharedNetworksModal" persistent width="750px">
      
    </v-dialog> -->
  </div>
</template>
<script>
import Api from "../services/Api";
export default {
  data() {
    return {
      activeTab: 'table',
      allNetworks: [],
      expand: true,
      item: {},
      key: 0,
      sharedNetworksModal: false,
      sharedPackageArray: [1],
      selectedNetworks: [],
      virtualProviders: [],
      headers: [
        {
          text: "Name",
          align: "center",
          value: "virtualProvider.name",
        },
        {
          text: "Networks Shared",
          align: "center",
          value: "id",
        },
      ],
      networkHeaders: [
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Packages Shared",
          align: "center",
          sortable: false
        },
        {
          text: "Network Status",
          align: "center",
          value: "networkStatus",
        },
        {
          text: "Backhaul Type",
          align: "center",
          value: "backhaulType",
        },
        {
          text: "No. Of Units",
          align: "center",
          value: "numberOfUnits",
        }
      ],
      networkPackageHeaders: [
        {
          text: "Shared",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Type",
          align: "center",
          value: "type",
        },
        {
          text: "Price (excl. VAT)",
          align: "center",
          value: "price",
        },
        {
          text: "Speed",
          align: "center",
          value: "speedProfile.downloadMbps",
        },
      ],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getVirtualProviders();
      this.getAllNetworks();
      // this.getVirtualProviderPackages();
    },
    getVirtualProviders() {
      Api()
        .get("/virtualProviderNetworkOperator/operator")
        .then(async (response) => {
          this.virtualProviders = response.data;
          this.virtualProviders.forEach(x=>{
            x.networkCount = [...new Set(
              x.sharedNetworks.map(
                item => item.locationNetworkId
              )
            )].length
          })
          // this.virtualProviders = await response.data.map(async x=>{
          //   x.packages = await this.getVirtualProviderPackages(x.virtualProviderId)
          // })
          console.log(this.virtualProviders)
        });
    },
    async getVirtualProviderPackages(id){
      let result = []
      await Api().get('/virtualFnoPackage/operator/'+id).then(response=>{
        result = response.data
      })
      return result
    },
    getAllNetworks() {
      Api()
        .get("/locationNetworks/basic/active")
        .then((response) => {
          this.allNetworks = response.data;
        });
    },
    async viewSharedNetworksModal(item) {
      this.item = item;
      // this.sharedPackageArray = this.item.sharedNetworks.map(x=>x.virtualFnoPackageId)
      await this.allNetworks.map(async x=>{
        x.sharedPackages = this.item.sharedNetworks.filter(y=>y.locationNetworkId === x.id)
        x.sharedPackages = x.sharedPackages.map(z=>({id: z.packagesFnoId, fkId: z.id}))
        // x.selectedArray = x.sharedPackages.map(z=>z.virtualFnoPackageId)
        x.initialSelectedArray = x.sharedPackages
      })
      console.log(this.allNetworks.find(x=>x.id == 20))
      this.sharedNetworksModal = true;
    },
    async saveChanges() {
      await this.allNetworks.forEach(async x=>{
        let initialArray = x.initialSelectedArray.map(y=>y.id).sort((a, b) =>b- a)
        let finalSelection = x.sharedPackages.map(y=>y.id).sort((a, b) =>b- a)
        // console.log({name: x.name, initialSelection: initialArray, finalArray: finalSelection})
        finalSelection.forEach(z=>{
          if(!initialArray.includes(z)){
            this.shareNetworkPackage({locationNetworkId: x.id, packagesFnoId: z, organisationId: this.item.virtualProviderId, isActive: true, isDeleted: false})
          }
        })
        initialArray.forEach(z=>{
          if(!finalSelection.includes(z)){
            let find = x.initialSelectedArray.find(a=>a.id === z)
            this.unsharePackage(find.fkId)
          }
        })
      })
      this.getVirtualProviders()
      this.sharedNetworksModal=false
    },
    async shareNetworkPackage(item){
      await Api().post('/virtualFnoPackageLocationNetwork', item)
    },
    async unsharePackage(id){
      await Api().put('/virtualFnoPackageLocationNetwork/'+id, {isActive: false, isDeleted: true})
    }
  },
};
</script>